import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const ANSPRECHPARTNER_ROUTES: AppRoutes = [
    {
        path: "",
        loadComponent: () => import('./components/ansprechpartner-carousel/ansprechpartner-carousel.component').then(mod => mod.AnsprechpartnerCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/ansprechpartner-home/ansprechpartner-home.component').then(mod => mod.AnsprechpartnerHomeComponent),
        title: 'YSTM - Ansprechpartner',
        data: {
            meta: {
                description: 'YSTM Ansprechpartner für ihre Themen'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];